import { store } from './store'
import authActions from './auth/actions'
import appActions from './app/actions'

export default () =>
  new Promise(() => {
    store.dispatch(authActions.checkAuthorization(localStorage.getItem('id_token')))
    store.dispatch(appActions.queryParamsCheck())
  })
